{
  "home": {
    "tagline": "Över 1 miljon hundägare tränar med Hundeo",
    "subline": "Rekommenderad av riktiga hundtränare",
    "appStorePrefix": "Hämta i",
    "playStorePrefix": "Hämta i",
    "qrHint": "Öppna appen på din telefon",
    "qrCaption": "Skanna koden med kameran",
    "socialProof": "5 000+ femstjärniga recensioner",
    "imprint": "Imprint",
    "privacy": "Integritet",
    "language": "Språk",
    "openWebsite": "Till webbplatsen",
    "openInApp": "Öppna i Hundeo-appen",
    "openInAppHint": "Du skickas vidare till din app",
    "openInAppButton": "Öppna",
    "promoRedirectTitle": "Ditt erbjudande öppnas …",
    "promoRedirectButton": "Till ditt erbjudande"
  }
}
